import { render } from "./SurveyPage.vue?vue&type=template&id=bd467b1a&ts=true"
import script from "./SurveyPage.vue?vue&type=script&lang=ts"
export * from "./SurveyPage.vue?vue&type=script&lang=ts"

import "./SurveyPage.vue?vue&type=style&index=0&id=bd467b1a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__